import { FC } from "react";
import { EMPTY_STRING } from "../../../../../common/constants/common.constants";
import "./StakingOptionCard.scss";
const StakingOptionCard: FC<{
  title: number | string;
  description?: number;
  isActive: boolean;
  isDisabled: boolean;
  isDepositModal?: boolean;
  onChooseStakingPeriod: (isDisabled: boolean, title: number | string) => void;
}> = ({
  title,
  description,
  isActive,
  isDisabled,
  isDepositModal,
  onChooseStakingPeriod,
}) => {
  return (
    <button
      disabled={isDisabled}
      onClick={() => onChooseStakingPeriod(isDisabled, title)}
      className={`${
        isActive ? "staking-period staking-period--active" : "staking-period"
      }`}
    >
      {isDisabled && <p className="staking-period__coming-soon">COMING SOON</p>}
      <div
        className={`${
          isActive
            ? "staking-period__time-wrapper staking-period__time-wrapper--active"
            : "staking-period__time-wrapper"
        }`}
      >
        <p
          className={`${
            isDisabled
              ? "staking-period__days staking-period__days--disabled"
              : isActive
              ? "staking-period__days staking-period__days--active"
              : "staking-period__days"
          }`}
        >
          {title} {`${!isDepositModal ? "days" : EMPTY_STRING}`}
        </p>
        {description && (
          <p className="staking-period__apy">{description}% APY</p>
        )}
      </div>
    </button>
  );
};

export default StakingOptionCard;
